import { render, staticRenderFns } from "./Talk4.vue?vue&type=template&id=5ee74ec6&scoped=true"
import script from "./Talk4.vue?vue&type=script&lang=js"
export * from "./Talk4.vue?vue&type=script&lang=js"
import style0 from "./Talk4.vue?vue&type=style&index=0&id=5ee74ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee74ec6",
  null
  
)

export default component.exports